import ResourcePage from "@/components/common/ResourcePage";

export default function CompaniesPage() {
  return (
    <ResourcePage
      title="Companies" subtitle="Companies across tenants (tenant-scoped organizations)"
      base="/v1/companies" perm="COMPANY"
      columns={[
        { key: "companyCode", header: "Code", render: (r) => <span className="font-mono text-xs font-semibold">{r.companyCode}</span> },
        { key: "companyName", header: "Name" },
        { key: "gstNumber", header: "GST", render: (r) => r.gstNumber || "—" },
        { key: "status", header: "Status" },
      ]}
      fields={[
        { name: "tenantId", label: "Tenant ID", hint: "Tenant this company belongs to" },
        { name: "companyCode", label: "Company Code" },
        { name: "companyName", label: "Company Name" },
        { name: "gstNumber", label: "GST Number" },
        { name: "panNumber", label: "PAN Number" },
        { name: "status", label: "Status", type: "select", options: ["Active", "Suspended"] },
      ]}
    />
  );
}
